import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCardActions,[_c(VSpacer),_c(VBtn,{attrs:{"color":"green","text":""},on:{"click":_vm.save}},[_vm._v(" Save ")]),_c(VBtn,{attrs:{"color":"red darken-1","text":""},on:{"click":_vm.close}},[_vm._v(" Cancel ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }